/*
  Sorts "Size: ..." lists on product cards into logical order
  (letter sizes XS -> XL -> plus sizes -> One Size, then numeric ascending,
  then unrecognized values alphabetically last), deduplicating repeats
  (the Searchspring feed lists one size per variant, e.g. "S, S, S, L").

  Needed because Searchspring Snap renders recommendation/search/collection
  cards client-side with sizes in ERP feed order.

  IMPORTANT: these spans are managed by Searchspring's preact renderer,
  which creates them as three text nodes (" Size: ", "<list>", " ").
  Never replace the span's textContent or children — collapsing the text
  nodes corrupts preact's DOM bookkeeping and re-renders then append
  duplicate text. Only ever rewrite the nodeValue of an existing text
  node, which is the same operation preact itself performs.
*/
(function () {
  var LETTER_ORDER = [
    '4XS', '3XS', 'XXXS', '2XS', 'XXS', 'XS', 'XS/S', 'S', 'S/M', 'M', 'M/L',
    'L', 'L/XL', 'XL', 'XL/XXL', 'XXL', '2XL', 'XXXL', '3XL', '4XL', '5XL',
    '6XL', '0X', '1X', '2X', '3X', '4X', '5X', '6X', 'OS', 'O/S', 'ONE SIZE',
    'ONESIZE'
  ];

  function sizeKey(value) {
    var up = value.trim().toUpperCase();
    var letterIndex = LETTER_ORDER.indexOf(up);
    if (letterIndex !== -1) return { group: 0, num: letterIndex, str: '' };
    var num = Number(up);
    if (up !== '' && !Number.isNaN(num)) {
      // all-zero sizes run smallest-first: 000 < 00 < 0
      if (/^0+$/.test(up)) num -= (up.length - 1) * 0.001;
      return { group: 1, num: num, str: '' };
    }
    return { group: 2, num: 0, str: up };
  }

  function compareSizes(a, b) {
    var ka = sizeKey(a);
    var kb = sizeKey(b);
    return (
      ka.group - kb.group ||
      ka.num - kb.num ||
      ka.str.localeCompare(kb.str, undefined, { numeric: true })
    );
  }

  var TEXT_NODE = 3;

  function sortSizeSpan(el) {
    var text = el.textContent;
    var match = text.match(/^(\s*Size:\s*)(.+?)(\s*)$/);
    if (!match || match[2].indexOf(',') === -1) return;

    var values = [];
    match[2].split(',').forEach(function (v) {
      v = v.trim();
      if (v && values.indexOf(v) === -1) values.push(v);
    });
    if (!values.length) return;
    var sortedList = values.sort(compareSizes).join(', ');

    var nodes = el.childNodes;
    if (nodes.length === 3 && nodes[1].nodeType === TEXT_NODE) {
      // Searchspring/preact structure: [" Size: ", "<list>", " "]
      if (nodes[1].nodeValue !== sortedList) nodes[1].nodeValue = sortedList;
    } else if (nodes.length === 1 && nodes[0].nodeType === TEXT_NODE) {
      var full = match[1] + sortedList + match[3];
      if (nodes[0].nodeValue !== full) nodes[0].nodeValue = full;
    }
  }

  function scan() {
    document.querySelectorAll('span.option').forEach(sortSizeSpan);
  }

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      scan();
    });
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
